import axios from "axios";
import authHeader from '../../../authheader'

const VFREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/FirmVfReinstatement";



const getBoardRecommendations = (reinstatementId) => {
    return axios.get(`${VFREINSTATEMENTURL}/boardrecommendations`, { headers: authHeader(), params: { reinstatementId } });
}
const getBoardResponses = (reinstatementId) => {
    return axios.get(`${VFREINSTATEMENTURL}/boardmemberresponses`, { headers: authHeader(), params: { reinstatementId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${VFREINSTATEMENTURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${VFREINSTATEMENTURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}